// @flow

import _ from 'lodash/fp';
import {combineReducers} from 'redux';
import {
  PROJECTS_REQUEST,
  PROJECTS_SUCCESS,
  PROJECTS_FAILURE,
  FILTER,
} from '../actions/salesView';

const error = (state = null, action) => {
  switch (action.type) {
    case PROJECTS_REQUEST:
    case PROJECTS_SUCCESS:
      return null;
    case PROJECTS_FAILURE:
      return action.error;
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case PROJECTS_REQUEST:
      return true;
    case PROJECTS_SUCCESS:
    case PROJECTS_FAILURE:
      return false;
    default:
      return state;
  }
};

const projects = (state = [], action) => {
  switch (action.type) {
    case PROJECTS_REQUEST:
      return [];
    case PROJECTS_SUCCESS:
      return action.projects;
    default:
      return state;
  }
};

const projectId = (state = null, action) => {
  switch (action.type) {
    case FILTER:
      return action.projectId;
    case PROJECTS_SUCCESS:
      return state || _.getOr(null, 'id', _.head(action.projects));
    default:
      return state;
  }
};

export default combineReducers({
  error,
  isFetching,
  projects,
  projectId,
});



// WEBPACK FOOTER //
// ./src/reducers/salesView.js